import React from "react";
import Title from "../../componenets/Title/Title.tsx";
import { JsonLD, JsonLDData } from "react-safe-json-ld";
import { initGA, logPageView } from '../../lib/analytics.ts';

interface LayoutProps {
  title?: string;
  children: React.ReactNode;
  structuredData?: JsonLDData;
}

const Layout: React.FC<LayoutProps> = ({ title, children, structuredData }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    initGA();
    logPageView(window.location.pathname);
  }, []);

  return (
    <>
      {structuredData && <JsonLD data={structuredData} />}
      <div className="min-h-screen bg-alt-wht flex flex-col">
        <Title title={title} />
        {/* Navbar */}
        <nav className="bg-alt-blk text-white py-6 sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="flex justify-between items-center">
              <div className="flex flex-row">
                <img
                  src="/images/earthboundmartian-mascot-inverted-rgb-300px-w-72ppi.png"
                  alt="Earthbound Martian"
                  className="h-14 sm:h-16 md:h-18 w-auto transition-all"
                />
                <img
                  src="/images/earthboundmartian-logotype-inverted-rgb-300px-w-72ppi.png"
                  alt="Earthbound Martian"
                  className="h-14 sm:h-16 md:h-18 w-auto transition-all"
                />
              </div>
              {/* Desktop Menu */}
              <div className="hidden md:flex space-x-8 text-lg font-large">
                <a href="/" className="hover:text-sunset transition-colors">
                  Home
                </a>
                <a href="/fleet" className="hover:text-sunset transition-colors">
                  Fleet
                </a>
                <a
                  href="/rentals"
                  className="hover:text-sunset transition-colors"
                >
                  Rentals
                </a>
                <a href="/about" className="hover:text-sunset transition-colors">
                  About
                </a>
                <a
                  href="/contact"
                  className="hover:text-sunset transition-colors"
                >
                  Contact
                </a>
              </div>

              {/* Mobile Menu Button */}
              <button
                className="md:hidden text-3xl leading-none"
                onClick={() => setIsOpen(!isOpen)}
              >
                ☰
              </button>
            </div>
            {/* Mobile Menu Dropdown */}
            {isOpen && (
              <div className="md:hidden mt-6 flex flex-col space-y-4 text-center text-lg">
                <a href="/" className="hover:text-sunset py-2">
                  Home
                </a>
                <a href="/fleet" className="hover:text-sunset py-2">
                  Fleet
                </a>
                <a href="/rentals" className="hover:text-sunset py-2">
                  Rentals
                </a>
                <a href="/about" className="hover:text-sunset py-2">
                  About
                </a>
                <a href="/contact" className="hover:text-sunset py-2">
                  Contact
                </a>
              </div>
            )}
          </div>
        </nav>

        {/* Page Content */}
        <main className="flex-1 flex flex-col">{children}</main>

        {/* Footer */}
        <footer className="bg-alt-blk text-white py-12 text-center text-sm mt-auto">
          © 2026 Earthbound Martian, LLC • Richardson, TX
        </footer>
      </div>
    </>
  );
};

export default Layout;
